var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconNotification = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_51",
    "data-name": "Group 51",
    width: 20.126,
    height: 20,
    viewBox: "0 0 20.126 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M63.135,104.125a2.734,2.734,0,0,0,2.205-1.088H60.93A2.737,2.737,0,0,0,63.135,104.125Z",
    transform: "translate(-53.073 -84.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M74.054,104.077l-3.3-5.127V95.029a6.86,6.86,0,0,0-5.468-6.717V87.6a1.276,1.276,0,0,0-1.2-1.293,1.242,1.242,0,0,0-1.28,1.241v.711a6.86,6.86,0,0,0-5.766,6.77V98.95l-3.012,5.138a.312.312,0,0,0,.269.47h7.986c-.012,0,2.776.008,3.53,0h7.984A.313.313,0,0,0,74.054,104.077ZM64.764,88.24H63.319v-.6a.724.724,0,1,1,1.446,0Zm4.4,6.431h-.017a.414.414,0,0,1-.417-.4,3.91,3.91,0,0,0-2.7-3.523.418.418,0,1,1,.307-.777,4.663,4.663,0,0,1,3.242,4.274A.417.417,0,0,1,69.16,94.671Z",
    transform: "translate(-53.979 -86.306)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconNotification, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_notification.4498b94c.svg";
export { ForwardRef as ReactComponent };